export type HeadLinkDescriptor = {
  rel: string;
  href: string;
  as?: string;
  type?: string;
  crossOrigin?: 'anonymous' | 'use-credentials' | '';
};

/**
 * TanStack Router `head().links` entries for Albert Sans preload + stylesheet.
 * Font files still live under each app's `public/fonts/` (identical assets).
 */
export function albertSansHeadLinks(basePath = '/fonts'): HeadLinkDescriptor[] {
  const normalized = basePath.replace(/\/$/, '');
  return [
    {
      rel: 'preload',
      as: 'font',
      type: 'font/woff2',
      href: `${normalized}/woff2/AlbertSans-Regular.woff2`,
      crossOrigin: 'anonymous',
    },
    {
      rel: 'preload',
      as: 'font',
      type: 'font/woff2',
      href: `${normalized}/woff2/AlbertSans-Medium.woff2`,
      crossOrigin: 'anonymous',
    },
    { rel: 'stylesheet', href: `${normalized}/fonts.css` },
  ];
}
